import Header from './Header'
import Footer from './Footer'
import Course from './Course'
import Blog from './Blog'
import style from './Home.module.css'

function Home(){
    return(
        <>
           <Header />
           <main>
                <section id="demo" className="carousel slide" data-bs-ride="carousel">
        
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="0" className="active"></button>
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button>
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="2"></button>
                    <button type="button" data-bs-target="#demo" data-bs-slide-to="3"></button>
                </div>


                <div className="carousel-inner">
                    <div className="carousel-item active">
                    <img src="assets/images/img1.jpg" alt="Los Angeles" className="d-block"  />
                    <div className="carousel-caption">
                        <h3 className={style.bg}>Los Angeles</h3>
                        <p className={style.p}>We had such a great time in LA!</p>
                    </div>
                    </div>
                    <div className="carousel-item">
                    <img src="assets/images/img2.jpg" alt="Chicago" className="d-block" />
                    <div className="carousel-caption">
                        <h3>Chicago</h3>
                        <p>Thank you, Chicago!</p>
                    </div> 
                    </div>
                    <div className="carousel-item">
                    <img src="assets/images/img3.jpg" alt="New York" className="d-block" />
                    <div className="carousel-caption">
                        <h3>New York</h3>
                        <p>We love the Big Apple!</p>
                    </div>  
                    </div>
                    <div className="carousel-item">
                    <img src="assets/images/img4.webp" alt="New York" className="d-block" />
                    <div className="carousel-caption">
                        <h3>New York</h3>
                        <p>We love the Big Apple!</p>
                    </div>  
                    </div>
                </div>


                <button className="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon"></span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                    <span className="carousel-control-next-icon"></span>
                </button>
                </section>
                
                <Course />
                
                <Blog />
                
                </main>
           
            <Footer />
        </>
    )
}

export default Home